import { RootState } from "../..";
import { OrderBookData } from "./types";

export const selectStockOrderBookData = (state: RootState): OrderBookData[] => state.public.stockOrderBook.orderBookDatas;
export const selectStockOrderBookLoading = (state: RootState):Boolean => state.public.stockOrderBook.loading;